import { render, staticRenderFns } from "./NpsGauge.vue?vue&type=template&id=24b07b2c&scoped=true&"
import script from "./NpsGauge.vue?vue&type=script&lang=js&"
export * from "./NpsGauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b07b2c",
  null
  
)

export default component.exports